var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3522 12.8863C29.7474 12.8863 30.0681 12.5656 30.0681 12.1704V3.57951C30.0681 1.6065 28.4616 0 26.4886 0H3.57951C1.6065 0 0 1.6065 0 3.57958V27.9205C0 29.8935 1.6065 31.5 3.57951 31.5H26.4885C28.4615 31.5 30.068 29.8935 30.068 27.9205V23.625C30.068 23.2298 29.7473 22.9091 29.3521 22.9091C28.9569 22.9091 28.6362 23.2298 28.6362 23.625V27.9205C28.6362 29.1046 27.6726 30.0682 26.4885 30.0682H3.57951C2.39538 30.0682 1.43179 29.1046 1.43179 27.9205V7.15909H28.6362V12.1705C28.6363 12.5656 28.957 12.8863 29.3522 12.8863ZM1.43179 5.7273V3.57958C1.43179 2.39545 2.39538 1.43186 3.57951 1.43186H26.4885C27.6727 1.43186 28.6362 2.39545 28.6362 3.57958V5.7273H1.43179Z",
    fill: "#8994A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21V18.7895M17 18.7895V15H19C19.6667 15 21 15.3789 21 16.8947C21 18.4105 19.6667 18.7895 19 18.7895H17Z",
    stroke: "#8994A6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21V15H26.8571C27.5714 15.1111 29 15.8667 29 18C29 20.1333 27.5714 20.8889 26.8571 21H24Z",
    stroke: "#8994A6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21V20.6842V17.8421M35 15H32V17.8421M32 17.8421H35",
    stroke: "#8994A6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.16f2d6d3.svg";
export { ForwardRef as ReactComponent };